import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import tableLiveScheduledEvents from './tableLiveScheduledEvents';


export default {
  title: 'Live Scheduled Events',
  attributeName: 'liveScheduledEvents',
  fields: [

    {
      attributeName: 'liveScheduledEventsTable',
      type: FormInputTypes.TABLECOMPONENT,
      helpText: '',
      configFile: tableLiveScheduledEvents,
    },
  ],
};
